import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Showcase = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.from('.showcase-img', {
                y: 60,
                opacity: 0,
                duration: 1.2,
                stagger: 0.2,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top 70%",
                }
            });
            gsap.from('.showcase-text', {
                y: 40,
                opacity: 0,
                duration: 1,
                stagger: 0.1,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top 70%",
                }
            });
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <section id="showcase" ref={containerRef} className="py-24 md:py-32 bg-[#0A0A14] relative z-40 rounded-t-[3rem] -mt-[3rem] shadow-[0_-20px_40px_rgba(10,10,20,0.8)] border-t border-[#7B61FF]/20">
            <div className="max-w-7xl mx-auto px-6 md:px-16">
                <div className="text-center mb-16 md:mb-24">
                    <span className="showcase-text text-[#7B61FF] font-data text-xs uppercase tracking-widest font-bold block mb-4">Hardware Base</span>
                    <h2 className="showcase-text text-[#F0EFF4] font-bold text-4xl md:text-5xl tracking-tight">
                        Choose Your <span className="font-drama text-[#7B61FF]">Form Factor.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
                    {/* Mac Mini */}
                    <div className="showcase-img flex flex-col items-center group cursor-pointer">
                        <div className="relative w-full aspect-square rounded-[2rem] overflow-hidden bg-[#0A0A14] mb-8 shadow-2xl">
                            <img
                                src="/images/generated/mac_mini_roofing.png"
                                alt="Obsidian Mac Mini with roofing blueprints"
                                className="w-full h-full object-cover transition-transform duration-[1s] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] group-hover:scale-105 opacity-90 group-hover:opacity-100 mix-blend-screen"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A14] to-transparent opacity-60"></div>
                            <div className="absolute bottom-6 left-6 font-data text-[#7B61FF] text-xs">MODEL: CORE_NODE</div>
                        </div>
                        <h3 className="text-[#F0EFF4] font-bold text-2xl mb-2">Obsidian Mac Mini</h3>
                        <p className="text-[#F0EFF4]/70 text-center max-w-sm">
                            The ultimate anchor node. Compact, silent, and relentlessly powerful. Ideal for fixed operational bases.
                        </p>
                    </div>

                    {/* MacBook Air */}
                    <div className="showcase-img flex flex-col items-center group cursor-pointer mt-0 md:mt-24">
                        <div className="relative w-full aspect-square rounded-[2rem] overflow-hidden bg-[#0A0A14] mb-8 shadow-2xl">
                            <img
                                src="/images/generated/macbook_roofing.png"
                                alt="Obsidian MacBook Air deployed at roofing job site"
                                className="w-full h-full object-cover transition-transform duration-[1s] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] group-hover:scale-105 opacity-90 group-hover:opacity-100 mix-blend-screen"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A14] to-transparent opacity-60"></div>
                            <div className="absolute bottom-6 left-6 font-data text-[#7B61FF] text-xs">MODEL: NOMAD_UNIT</div>
                        </div>
                        <h3 className="text-[#F0EFF4] font-bold text-2xl mb-2">Obsidian MacBook Air</h3>
                        <p className="text-[#F0EFF4]/70 text-center max-w-sm">
                            Deploy from anywhere. Untethered command center with extreme battery life and full OpenClaw capabilities.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Showcase;
